import { useMutation } from '@tanstack/react-query';

import { uploadFileToS3 } from '@/helpers';
import { useApiMutation, useFetch } from '@/modules/common';

import { CreateStyleBody, StylesUploadUrlData } from '../types';

export function useCreateStyle() {
  const fetchClient = useFetch();

  const getUploadUrlDataMutation = useMutation<
    StylesUploadUrlData & { file: File },
    undefined,
    { file: File }
  >({
    mutationFn: async ({ file }) => {
      const res = await fetchClient('/styles/upload-url', {
        method: 'GET',
      });
      return { ...res, file };
    },
    onSuccess: async ({ styleImageUploadUrl, file }) => {
      await uploadFileToS3({
        file,
        uploadUrl: styleImageUploadUrl,
      });
    },
  });

  const createStyleMutation = useApiMutation<CreateStyleBody>('/styles', {
    method: 'POST',
  });

  return {
    getUploadUrlDataMutation,
    createStyleMutation,
  } as const;
}
